<app-home-fundamentals-card [type]="cardType" [content]="contentTemplate" [actions]="actionsTemplate">
</app-home-fundamentals-card>

<ng-template #contentTemplate>
    <ng-container *ngIf="productIdeasLab$ | async as productIdeasLab; else loading">
        <ul>
            <li *ngFor="let link of productIdeasLab.links">
                <a [href]="link.url" [attr.data-analytics]="link.dataAnalytics?.join('-')">
                    {{ link.label }}
                </a>
            </li>
        </ul>
    </ng-container>
    <ng-template #loading>
        <ul>
            <li>
                <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            </li>
            <li>
                <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            </li>
        </ul>
        <app-loading-skeleton [rows]="1" [rowHeight]="20"></app-loading-skeleton>
    </ng-template>
</ng-template>

<ng-template #actionsTemplate>
    <ng-container *ngIf="productIdeasLab$ | async as productIdeasLab">
        <ng-container *ngIf="productIdeasLab?.action">
            <a
                class="action link-btn"
                [href]="productIdeasLab.action.url"
                target="_blank"
                matTooltip="Visit the Product Ideas Lab in a new tab"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                [attr.data-analytics]="productIdeasLab.action.dataAnalytics?.join('-')">
                {{ productIdeasLab.action.label }}
                <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
            </a>
        </ng-container>
    </ng-container>
</ng-template>
